export default function DSA_Simple_Algorithm() {
  return <div>DSA_Simple_Algorithm Component</div>;
}
